import classname from 'classname';
import { PhonePreviewIcon, SearchIcon } from 'components/icons';
import React from 'react';
import styles from './preview.module.scss';
export default function PhonePreview({ title, children }) {
  return (
    <div className={classname(styles.phone)}>
      <div className={styles.screen}>
        <div className={styles.header}>
          <h3 className={styles.title}>{title}</h3>
          <SearchIcon />
        </div>
        <div className={styles.body}>{children}</div>
      </div>
      <PhonePreviewIcon style={{ position: 'relative' }}></PhonePreviewIcon>
    </div>
  );
}
